import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { deDupeAsyncFunction, assertTokenProviderConfig, decodeJWT } from '@aws-amplify/core/internals/utils';
import { initiateAuth } from './clients/CognitoIdentityProvider/index.mjs';
import { getRegion } from './clients/CognitoIdentityProvider/utils.mjs';
import { assertAuthTokensWithRefreshToken } from './types.mjs';
import { AuthError } from '../../../errors/AuthError.mjs';
import { getUserContextData } from './userContextData.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var refreshAuthTokensFunction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _tokens$deviceMetadat, _authConfig$Cognito, _AuthenticationResult;

    var tokens, authConfig, username, region, refreshTokenString, AuthParameters, UserContextData, _yield$initiateAuth, AuthenticationResult, accessToken, idToken, iat, clockDrift;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokens = _ref.tokens, authConfig = _ref.authConfig, username = _ref.username;
            assertTokenProviderConfig(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
            region = getRegion(authConfig.Cognito.userPoolId);
            assertAuthTokensWithRefreshToken(tokens);
            refreshTokenString = tokens.refreshToken;
            AuthParameters = {
              REFRESH_TOKEN: refreshTokenString
            };

            if ((_tokens$deviceMetadat = tokens.deviceMetadata) !== null && _tokens$deviceMetadat !== void 0 && _tokens$deviceMetadat.deviceKey) {
              AuthParameters.DEVICE_KEY = tokens.deviceMetadata.deviceKey;
            }

            UserContextData = getUserContextData({
              username: username,
              userPoolId: authConfig.Cognito.userPoolId,
              userPoolClientId: authConfig.Cognito.userPoolClientId
            });
            _context.next = 10;
            return initiateAuth({
              region: region
            }, {
              ClientId: authConfig === null || authConfig === void 0 ? void 0 : (_authConfig$Cognito = authConfig.Cognito) === null || _authConfig$Cognito === void 0 ? void 0 : _authConfig$Cognito.userPoolClientId,
              AuthFlow: 'REFRESH_TOKEN_AUTH',
              AuthParameters: AuthParameters,
              UserContextData: UserContextData
            });

          case 10:
            _yield$initiateAuth = _context.sent;
            AuthenticationResult = _yield$initiateAuth.AuthenticationResult;
            accessToken = decodeJWT((_AuthenticationResult = AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.AccessToken) !== null && _AuthenticationResult !== void 0 ? _AuthenticationResult : '');
            idToken = AuthenticationResult !== null && AuthenticationResult !== void 0 && AuthenticationResult.IdToken ? decodeJWT(AuthenticationResult.IdToken) : undefined;
            iat = accessToken.payload.iat; // This should never happen. If it does, it's a bug from the service.

            if (iat) {
              _context.next = 17;
              break;
            }

            throw new AuthError({
              name: 'iatNotFoundException',
              message: 'iat not found in access token'
            });

          case 17:
            clockDrift = iat * 1000 - new Date().getTime();
            return _context.abrupt("return", {
              accessToken: accessToken,
              idToken: idToken,
              clockDrift: clockDrift,
              refreshToken: refreshTokenString,
              username: username
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function refreshAuthTokensFunction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var refreshAuthTokens = deDupeAsyncFunction(refreshAuthTokensFunction);
export { refreshAuthTokens };